<mbs-form-group class="mb-0 text-sm">
  <mbs-select
    [appendTo]="appendTo()"
    [attr.data-e2e]="e2eLocators()?.companyControl"
    [bindLabel]="bindLabel"
    [clearable]="clearable()"
    [formControl]="control"
    [isAutoWidth]="false"
    [isCheckboxOverflow]="multiple()"
    [isCheckboxSelect]="multiple()"
    [isCounterShowing]="multiple() && !!counterLabel()"
    [items]="items()"
    [label]="label()"
    [labelForCounter]="counterLabel()"
    [loading]="loading()"
    [multiple]="multiple()"
    [placeholder]="placeholder()"
    [searchable]="searchable()"
    [showRequiredMark]="showRequiredMark()"
    [typeahead]="typeahead$"
    [virtualScroll]="true"
    (clear)="clearEvent.emit()"
    (close)="closeEvent.emit()">
    @if (showAddNewButton() && (permissionsEnum.ManageCompanies | can: 'read') && (permissionsEnum.AccessToAllCompanies | can: 'read')) {
      <ng-template #mbsSelectFooterTmp>
        <mbs-button
          [attr.data-e2e]="e2eLocators()?.addNewBtn"
          [isCtrl]="true"
          (click)="onAddCompanyButtonClick()"
          >{{ 'shared:computers.addNewCompany' | i18next }}</mbs-button
        >
      </ng-template>
    }
  </mbs-select>
</mbs-form-group>
